import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import type { SwitchProps } from './Switch.types'
import './switch.scss'

const Switch = ({
  label,
  color,
  size,
  checked,
  disabled,
  error,
  onChange,
}: SwitchProps) => {
  const [isChecked, setIsChecked] = useState(checked)

  const isDisabled = disabled ? 'sb-switch--disabled' : ''
  const hasError = error ? 'sb-switch--error' : ''
  const isActive = !error && isChecked ? 'sb-switch--active' : ''

  useEffect(() => {
    onChange && onChange(isChecked)
  }, [isChecked])

  return (
    <div
      className={[
        'sb-switch',
        `sb-switch--${color}`,
        `sb-switch--${size}`,
        isActive,
        isDisabled,
        hasError,
      ].join(' ')}
      data-testid='sb-switch'
    >
      {label && <span className='sb-switch__text'> {label}</span>}
      <label
        className='sb-switch__container'
        data-testid='sb-switch__container'
      >
        <input
          type='checkbox'
          className='sb-switch__input'
          data-testid='sb-switch__input'
          disabled={disabled}
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
        <span className='sb-switch__slider' data-testid='sb-switch__slider' />
      </label>
    </div>
  )
}

Switch.propTypes = {
  /**
   * Switch label
   */
  label: PropTypes.string.isRequired,
  /**
   * Size
   */
  size: PropTypes.oneOf(['sm', 'md']),
  /**
   * checked?
   */
  checked: PropTypes.bool,
  /**
   * Color of switch
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  /**
   * Disabled?
   */
  disabled: PropTypes.bool,
  /**
   * error?
   */
  error: PropTypes.bool,
  /**
   * onChange?
   */
  onChange: PropTypes.func,
}

Switch.defaultProps = {
  label: 'switch text',
  size: 'sm',
  color: 'primary',
  checked: false,
  error: false,
  disabled: false,
  onChange: () => {},
}

export default Switch
